import React, { useContext } from "react";
import api from "axios_interceptor/interceptor";
import { Button, Text } from "@radix-ui/themes";
import { FilePlusIcon, StackIcon } from "@radix-ui/react-icons";
import { SideBarActiveContext } from "context/SideBarActiveContext";
import { YourGeneratedPodcastContext } from "context/LibraryYourGeneratedPodcastContext";

const SideBar = () => {
  const { setCurrentSideBarActive } = useContext(SideBarActiveContext);
  const { setCurrentYourGeneratedPodcast } = useContext(
    YourGeneratedPodcastContext
  );

  const handleOnClick = (stateName) => {
    setCurrentSideBarActive(stateName);
    // Fetch my generated podcast list if lib button is clicked
    if (stateName === "lib") {
      fetchMyGeneratedPodcasts();
    }
  };

  const fetchMyGeneratedPodcasts = async () => {
    try {
      const response = await api.post("/utils/audio-check-by-user", {});
      const audioQueue = response.data.content;
      setCurrentYourGeneratedPodcast(audioQueue); // Update podcast queue
    } catch (error) {
      console.error("Error fetching audio status:", error);
    }
  };

  return (
    <>
      <div
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          display: "flex",
          flexDirection: "column",
          //   backgroundColor: "red",
          width: "100%",
        }}
      >
        <div
          style={{
            paddingTop: "20px",
            paddingLeft: "5px",
            paddingRight: "5px",
            paddingBottom: "5px",
          }}
        >
          <Text size="5" weight="medium">
            Home
          </Text>
        </div>

        <div
          style={{
            paddingTop: "10px",
            paddingLeft: "5px",
            paddingRight: "5px",
            paddingBottom: "10px",
          }}
        >
          <Button
            variant="ghost"
            size="3"
            style={{
              width: "100%",
              justifyContent: "flex-start",
              display: "flex",
              cursor: "pointer",
            }}
            onClick={() => handleOnClick("create")}
          >
            <FilePlusIcon />
            <Text size="3" weight="medium">
              Create
            </Text>
          </Button>
        </div>

        <div
          style={{
            paddingTop: "10px",
            paddingLeft: "5px",
            paddingRight: "5px",
            paddingBottom: "10px",
          }}
        >
          <Button
            variant="ghost"
            size="3"
            style={{
              width: "100%",
              justifyContent: "flex-start",
              display: "flex",
              cursor: "pointer",
            }}
            onClick={() => handleOnClick("lib")}
          >
            <StackIcon />
            <Text size="3" weight="medium">
              Library
            </Text>
          </Button>
        </div>
      </div>
    </>
  );
};

export default SideBar;
